import { useMutation } from '@apollo/client';
import { COMPANY_FEATURE_OPT_IN } from '../graphql/CompanyFeatureOptInMutation.gql';

export type UserError = { error: string; message: string; path: string[] };

type OptInResult = {
  success: boolean;
  errors: UserError[];
};

const useCompanyFeatureOptIn = (): {
  optInToFeature: (feature: string) => Promise<OptInResult>;
  loading: boolean;
} => {
  const [companyFeatureOptIn, { loading }] = useMutation(
    COMPANY_FEATURE_OPT_IN,
  );

  const optInToFeature = async (feature: string): Promise<OptInResult> => {
    const response = await companyFeatureOptIn({
      variables: {
        feature,
      },
    });

    if (response.data.companyFeatureOptIn.success) {
      return {
        success: true,
        errors: [],
      };
    } else {
      return {
        success: false,
        errors: response.data.companyFeatureOptIn.errors,
      };
    }
  };

  return {
    optInToFeature,
    loading,
  };
};

export default useCompanyFeatureOptIn;
